import React, { createContext, useState, useEffect, useContext } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  signOutUser,
  signInWithGoogleService,
  signInWithEmailService,
  signUpWithEmailService,
  mapFirebaseUserToAppUser,
} from "../services/userService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(mapFirebaseUserToAppUser(firebaseUser));
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const signInWithGoogle = async () => {
    try {
      const signedInUser = await signInWithGoogleService();
      setUser(signedInUser);
    } catch (error) {
      console.error("Failed to sign in: ", error);
    }
  };

  const signInWithEmail = async (email, password) => {
    try {
      const signedInUser = await signInWithEmailService(email, password);
      setUser(signedInUser);
      return signedInUser;
    } catch (error) {
      console.error("Failed to sign in with email: ", error);
      throw error;
    }
  };

  const signUpWithEmail = async (email, password) => {
    try {
      const createdUser = await signUpWithEmailService(email, password);
      setUser(createdUser);
      return createdUser;
    } catch (error) {
      console.error("Failed to create account with email: ", error);
      throw error;
    }
  };

  const signOut = async () => {
    try {
      await signOutUser();
      setUser(null);
    } catch (error) {
      console.error("Failed to sign out: ", error);
    }
  };

  return (
    <UserContext.Provider value={{ user, loading, signInWithGoogle, signInWithEmail, signUpWithEmail, signOut }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
